import React from "react";
import clsx from "clsx";

import bg from "./signin-with-google.png";

type LoginWithGoogleButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export function LoginWithGoogleButton({
  className,
  style,
  ...props
}: LoginWithGoogleButtonProps) {
  return (
    <button
      className={clsx(
        "block h-[50px] w-[208px] border-0 p-0 disabled:opacity-50 disabled:grayscale",
        className
      )}
      style={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        ...style,
      }}
      {...props}
    />
  );
}
